import { MappingDataView as UI } from "./ui/MappingDataView";
import { api } from "../../shared/api";
import { useState, useEffect } from "react";
import { Loading } from "../Loading";
import { Error } from "../Error";

export const MappingDataView = ({ scopeStringId, toastRef }) => {
  const componentState = useState({
    status: "loading",
    refreshesNumber: 0,
  });

  const [componentStateValue, setComponentStateValue] = componentState;

  const mappingFieldsArrState = useState([]);
  const [, setMappingFieldsArrStateValue] = mappingFieldsArrState;

  const controlButtonStringIdState = useState("add");

  useEffect(() => {
    (async () => {
      setComponentStateValue((prevValue) => ({
        ...prevValue,
        status: "loading",
      }));

      const getMappingFieldsResponseObj = await api.mappingFields.get(scopeStringId);

      const { warning, error } = getMappingFieldsResponseObj;

      if (error || warning) {
        setComponentStateValue((prevValue) => ({
          ...prevValue,
          status: "error",
          error: error || warning,
        }));
        return;
      }
      setMappingFieldsArrStateValue(getMappingFieldsResponseObj.member);
      setComponentStateValue((prevValue) => ({
        ...prevValue,
        status: "success",
      }));
      const [, setControlButtonStringIdStateValue] = controlButtonStringIdState;
      setControlButtonStringIdStateValue("add");
    })();
  }, [componentStateValue.refreshesNumber]);



  if (componentStateValue.status === "loading") return <Loading />;
  if (componentStateValue.status === "error")
    return <Error error={componentStateValue?.error} />;
  if (componentStateValue.status === "success")
    return (
      <UI
        componentState={componentState}
        scopeStringId={scopeStringId}
        mappingFieldsArrState={mappingFieldsArrState}
        toastRef={toastRef}
        controlButtonStringIdState={controlButtonStringIdState}
      />
    );
};
